import Link from 'next/link'
import { Container } from 'react-bootstrap'
import { YWPCreateAccount } from '@components/Block'

function Hero (props) {
    return (
        <div className="hero overflow-hidden">
            <Container className="position-relative">
                    <div className="hero__desc mt-xl-0 pt-4">
                        {/* <img src="../images/home/logo.png" alt="logo" className="img-fluid mb-4"/> */}
                        <p>&nbsp;</p>
                        <h1 className="hero__title font-weight-normal">Let's Turn Sick Care Into Well Care!</h1>
                        <p className="mb-4">Join our thriving community of wellness-minded families and <br className="d-md-block d-none"/> unlock access to trusted resources, expert interviews and more.</p>
                        <YWPCreateAccount site={props.site} metadata={props.metadata} bgcolor="bg-green" txtcolor="text-white"/>
                         {props.site.auth.isAuthenticated != true ? <p>Have an account? <Link href="/login"><a className="text-green">Login</a></Link></p> : ''}
                    </div>
                    <img src="../images/home/desktop03.png" alt="desktop" className="img-fluid hero__desktop position-absolute d-block m-auto"/>
            </Container>
    <style jsx>{`

        .hero{
            background: #efefef url(../images/home/bg.png) no-repeat;
            background-size:contain;
            padding: 5rem 1rem;
        }   
        
        .hero__desktop{
            bottom: -8rem;
            right: 0;
            max-width: 68%;
        }

        .hero__title{
            font-size: 1.86rem;
        }

        @media (max-width:1199px){
            .hero{
                padding: 4rem 1rem;
            }

            .hero__desktop{
                width:60%;
                bottom: -3rem;
            }
        }
        @media (max-width:991px){
            .hero{
                padding:0;
                background-image: url(../images/img-resource-center-bg-left-mobile01.png), url(../images/img-resource-center-bg-right-mobile01.png);
                background-size: initial;
                background-repeat: no-repeat;
                background-position: left center, right center;
            }

            .hero__desktop{
                position:relative!important;
                bottom: 0rem;
            }
            .hero__desc{
                text-align:center;
            }
        }
        @media (max-width:767px){
            .hero__title{
                font-size: 1.6rem;
            }
            .hero__desktop{
                width: 100%;
                left: -3rem;
            }
        }
    `}</style>
        </div>
    );
}

export default Hero;